<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-secondary pl-3 pr-0 py-0 shadow" id="main-nav">
            <div class="container-fluid h-100 px-0">
                <a href="https://templed.de/" class="navbar-brand py-2">
                    <h1 class="p-0 m-0"><img :src="asset('img/logo/templed-gmbh-w.png')" :alt="$t('tempLED Product Configurator')" ></h1>
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" :aria-label="$t('Open menu')">
                    <i class="fas fa-bars color-primary"></i>
                </button>

                <div class="collapse navbar-collapse h-100" id="navbarSupportedContent">
                    <!-- Left Side Of Navbar -->
                    <ul class="navbar-nav mr-auto">
                    </ul>

                    <!-- Right Side Of Navbar -->
                    <ul class="navbar-nav ml-auto h-100" id="user-login-nav">

                        <li class="nav-item align-middle h-100 d-flex px-4">
                            <router-link exact :to="{ name: 'home' }" class="nav-link my-auto text-uppercase text-white px-0"><span class="pb-1">{{ $t('Configurator') }}</span></router-link>
                        </li>
                        <li class="nav-item align-middle h-100 d-flex px-4" v-if="!authenticated">
                            <router-link exact :to="{ name: 'login' }" class="nav-link my-auto text-uppercase text-white px-0"><span class="pb-1">{{ $t('Sign in') }}</span></router-link>
                        </li>
                        <li class="nav-item align-middle h-100 d-flex px-4" v-if="!authenticated">
                            <router-link exact :to="{ name: 'register' }" class="nav-link my-auto text-uppercase text-white px-0"><span class="pb-1">{{ $t('Register') }}</span></router-link>
                        </li>
                        <!-- Logged in -->
                        <li class="nav-item align-middle h-100 d-flex px-4" v-if="authenticated">
                            <router-link exact :to="{ name: 'projects.index' }" class="nav-link my-auto text-uppercase text-white px-0"><span class="pb-1">{{ $t('My Projects') }}</span></router-link>
                        </li>
                        <li class="nav-item dropdown align-middle h-100 d-flex px-4" v-if="authenticated && $can('edit_users')">
                            <a id="navbarDropdown1" class="nav-link dropdown-toggle my-auto text-uppercase text-white px-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ $t('Administration') }}</a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown1" v-if="authenticated">
                                <router-link exact :to="{ name: 'users.index' }" class="dropdown-item text-uppercase"><span class="pb-1">{{ $t('Customer overview') }}</span></router-link>
                                <router-link exact :to="{ name: 'customerProjects.index' }" class="dropdown-item text-uppercase"><span class="pb-1">{{ $t('Project overview') }}</span></router-link>
                            </div>
                        </li>
                        <li class="nav-item dropdown align-middle h-100 d-flex px-4" v-if="authenticated">
                            <a id="navbarDropdown2" class="nav-link dropdown-toggle my-auto text-uppercase text-white px-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ $t('My account') }}</a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown2" v-if="authenticated">
                                <router-link exact :to="{ name: 'users.edit', params: { id: user.id } }" class="dropdown-item text-uppercase"><span class="pb-1">{{ $t('Edit account') }}</span></router-link>
                                <a class="dropdown-item text-uppercase" @click.prevent="signOut" style="cursor:pointer;">{{ $t('Log out') }}</a>
                            </div>
                        </li>
                        <li class="nav-item btn-primary h-100 px-4">
                            <a class="nav-link text-white h-100 d-flex text-uppercase px-0" href="https://templed.de/kontakt/"><span class="my-auto">{{ $t('Contact sales') }}</span></a>
                        </li>
                        <language-dropdown class="nav-item align-middle h-100 d-flex px-4" />
                    </ul>

                </div>
            </div>
        </nav>

        <main class="p-0 min-vh-100 bg-dark text-light">
            <router-view></router-view>
        </main>

        <footer class="d-none d-md-block" :class="this.$route.name === 'rayline' || this.$route.name === 'plannings.edit' ? 'd-none d-sm-block' : ''">
            <p class="fs-6 py-2 px-4 m-0 text-center text-sm-right default-footer bg-secondary text-white shadow">© {{ new Date().getFullYear() }} tempLED GmbH · <a href="https://templed.de/en/privacy-policy/" target="_blank">{{ $t('Privacy policy') }}</a> · <a :href="$t('https://templed.de/en/imprint/')" target="_blank">{{ $t('Imprint') }}</a> · <a :href="$t('https://templed.de/en/infos-configurator/')" target="_blank">{{ $t('Update Info') }}</a> · Powered by <a href="https://des21.com/" target="_blank">des21</a></p>
        </footer>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {

    data() {
        return {
            updatePopupShown: false,
            shouldShowUpdatePopup: false,
        }
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions',
            latestUpdateNotification: 'updateNotification/latestUpdateNotification',
            latestEnforcedUpdateNotification: 'updateNotification/latestEnforcedUpdateNotification',
        }),
    },

    mounted() {
        this.getLatestUpdateNotificationAction();
        this.getLatestEnforcedUpdateNotificationAction();
    },

    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut',
            getLatestUpdateNotificationAction: 'updateNotification/getLatestUpdateNotification',
            getLatestEnforcedUpdateNotificationAction: 'updateNotification/getLatestEnforcedUpdateNotification',
        }),

        translate(name) {
            try {
                JSON.parse(name);
            } catch (e) {
                return name;
            }
            let translated = JSON.parse(name);
            return translated[this.$i18n.locale]
        },

        async signOut () {
            await this.signOutAction()
            if (this.$route.name !== 'home') {
                await this.$router.push({ name: 'home' });
            }
        },

        setUpdatePopupShown() {
            localStorage.setItem('updatePopupShown', this.latestUpdateNotification.version_number);
        },

        checkUpdatePopupStatus() {
            this.updatePopupShown = localStorage.getItem('updatePopupShown');

            if (!this.updatePopupShown || this.updatePopupShown !== this.latestUpdateNotification.version_number) {
                this.$swal({
                    title: !this.$i18n.locale || this.$i18n.locale === 'de' ? this.latestUpdateNotification.title : this.latestUpdateNotification.title_en,
                    text: !this.$i18n.locale || this.$i18n.locale === 'de' ? this.latestUpdateNotification.description : this.latestUpdateNotification.description_en,
                    icon: 'info',
                    showCloseButton: true,
                    showCancelButton: true,
                    cancelButtonText: this.$t('Close'),
                    confirmButtonText: this.$t('Details'),
                    confirmButtonColor: '#3CA2A4',
                    iconColor: '#3CA2A4',
                }).then((result) => {
                    if (result.isConfirmed) {
                        let url = !this.$i18n.locale || this.$i18n.locale === 'de' ? 'https://templed.de/infos-konfigurator/' : 'https://templed.de/en/infos-configurator/,'
                        window.open(url, '_blank');
                    }
                    this.setUpdatePopupShown();
                });
            }
        },


    },

    watch: {
        latestUpdateNotification() {
            if (this.latestUpdateNotification) {
                this.checkUpdatePopupStatus();
            }
        },
    },
}

</script>
